export default __webpack_public_path__ + "static/media/care-small.a2d812c9.svg";